<mat-slide-toggle *ngIf="selectable" class="auto-select-toggle" [checked]="autoSelectSubfolders" (change)="onAutoSelectToggleChanged($event.checked)">
  {{ 'dataManagement.directory.autoSelectSubfolders' | transloco }}
</mat-slide-toggle>

<div class="selection-bar" 
[ngClass]="isDarkTheme ? 'selection-bar-dark' : ''"
*ngIf="selectable && selectedFolderIds.length > 0">
  <span class="selection-bar-count"> {{ selectedFolderIds.length }} {{ 'dataManagement.directory.foldersSelected' | transloco }} </span>
  <button mat-button class="selection-bar-clear" (click)="clearSelection()">
    {{ 'dataManagement.directory.clearSelection' | transloco }}
  </button>
</div>

<mat-tree #nestedTree [dataSource]="treeDataSource" [treeControl]="nestedTreeControl" class="dir-tree">
  <mat-nested-tree-node *matTreeNodeDef="let node">
    <div
      class="mat-tree-node cursor"
      [ngClass]="selectedFolder === node ? (isDarkTheme ? 'background-highlight-dark' : 'background-highlight') : ''"
      (click)="toggleFolder(node)">
      <button
        mat-icon-button
        [attr.aria-label]="'Toggle ' + node.name"
        matTreeNodeToggle
        (click)="$event.stopPropagation(); onTreeInteraction()"
        [ngClass]="{ invisible: !hasChild(node) }">
        <mat-icon>
          {{ nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>

      <mat-checkbox *ngIf="selectable && node.id !== recyclingBinDtoFolder.id" [checked]="isSelected(node)" (click)="$event.stopPropagation()" (change)="toggleFolder(node)">
      </mat-checkbox>

      <mat-icon class="tree-icon" *ngIf="node.id !== recyclingBinDtoFolder.id; else recyclingBinIcon">folder</mat-icon>
      <ng-template #recyclingBinIcon>
        <mat-icon class="tree-icon">delete</mat-icon>
      </ng-template>
      <div>{{ node.name }}</div>

      <span class="tree-node-spacer"></span>

      <button
        mat-icon-button
        class="tree-node-menu"
        *ngIf="selectable && node.id !== recyclingBinDtoFolder.id"
        [attr.aria-label]="'Menu ' + node.name"
        (click)="$event.stopPropagation(); openContextMenu($event, node)">
        <mat-icon>more_vert</mat-icon>
      </button>

    </div>
    <div [class.dir-tree-invisible]="!nestedTreeControl.isExpanded(node)" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>
